import { ProgressIndicator } from "@salesforce/design-system-react";

import { Button } from "@vimeo/iris/components";
import { MouseEvent } from "react";

export interface Step {
    id: number;
    label: string;
    value: string;
}

interface Props {
    steps: Step[];
    selectedStep: Step;
    completedSteps: Pick<Step, "id">[];
    onStepClick: (e: any, data: any) => void;
    onClose: () => void;
    disableNextButton: boolean;
}

export function Footer(props: Props) {
    const {
        disableNextButton,
        steps,
        selectedStep,
        completedSteps,
        onStepClick,
        onClose,
    } = props;

    return (
        <>
            <div
                key="progress-indicator"
                style={{
                    flex: 0.7,
                }}
            >
                <ProgressIndicator
                    className="slds-m-left_none"
                    steps={steps}
                    selectedStep={selectedStep}
                    completedSteps={completedSteps}
                />
            </div>
            {
                // Show the back button only for the first two steps,
                // since it doesn't make sense for the user to go back
                // after the content builder asset has been created.
            }
            <div style={{ display: "flex", justifyContent: "end", flex: 0.3 }}>
                {selectedStep.id > 0 && selectedStep.id < steps.length - 1 ? (
                    <Button
                        key="back-button"
                        format="secondary"
                        className="slds-var-m-right_small"
                        onClick={(e: MouseEvent<HTMLButtonElement>) =>
                            onStepClick(e, { step: steps[--selectedStep.id] })
                        }
                    >
                        Back
                    </Button>
                ) : (
                    ""
                )}
                {
                    // Show the next button only for the first two steps.
                    // Once the asset has been created, we'll automatically
                    // transition the user to the last step.
                }
                {selectedStep.value === "choose-asset" ||
                selectedStep.value === "configure-asset" ? (
                    <Button
                        key="next-button"
                        disabled={disableNextButton}
                        format="primary"
                        onClick={(e: MouseEvent<HTMLButtonElement>) =>
                            onStepClick(e, { step: steps[++selectedStep.id] })
                        }
                    >
                        Next
                    </Button>
                ) : selectedStep.id === steps.length - 1 ? (
                    <Button
                        key="close-button"
                        format="primary"
                        onClick={onClose}
                    >
                        Close
                    </Button>
                ) : (
                    ""
                )}
            </div>
        </>
    );
}
